import {Dispatch, SetStateAction, useCallback, useEffect, useState} from 'react'
import {BackendApi} from '../../../../../api/api.ts'
import {ClientAdministration, getClientAdministration} from '../../../../../lib/payrollAdministration.ts'

const LOAD_ERROR_MESSAGE = 'Loonadministratie kon niet worden geladen. Controleer de koppeling met je salarispakket.'

interface UsePayrollAdministrationResult {
    administration: ClientAdministration | null
    setAdministration: Dispatch<SetStateAction<ClientAdministration | null>>
    isLoading: boolean
    loadError: string | null
    refetch: () => Promise<ClientAdministration | null>
}

export function usePayrollAdministration(api: BackendApi, businessId: string): UsePayrollAdministrationResult {
    const [administration, setAdministration] = useState<ClientAdministration | null>(null)
    const [isLoading, setIsLoading] = useState(true)
    const [loadError, setLoadError] = useState<string | null>(null)

    const refetch = useCallback(async (): Promise<ClientAdministration | null> => {
        setIsLoading(true)
        setLoadError(null)
        try {
            const result = await getClientAdministration(api, businessId)
            setAdministration(result)
            return result
        } catch {
            setLoadError(LOAD_ERROR_MESSAGE)
            return null
        } finally {
            setIsLoading(false)
        }
    }, [api, businessId])

    useEffect(() => {
        void refetch()
    }, [refetch])

    return {administration, setAdministration, isLoading, loadError, refetch}
}
